import { render, staticRenderFns } from "./SpasmsChart.vue?vue&type=template&id=6e5de522&scoped=true&"
import script from "./SpasmsChart.vue?vue&type=script&lang=js&"
export * from "./SpasmsChart.vue?vue&type=script&lang=js&"
import style0 from "./SpasmsChart.vue?vue&type=style&index=0&id=6e5de522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5de522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VBtnToggle,VCard})
